import { render, staticRenderFns } from "./CustomerDetail1.vue?vue&type=template&id=68e3b892&scoped=true"
import script from "./CustomerDetail1.vue?vue&type=script&lang=js"
export * from "./CustomerDetail1.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail1.vue?vue&type=style&index=0&id=68e3b892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3b892",
  null
  
)

export default component.exports